import Vue from "vue";
import VueCompositionAPI, { ref } from "@vue/composition-api";
Vue.use(VueCompositionAPI);
const parcels = ref(null);
const pageId = ref(0);
export const useParcels = () => {
    const getParcels = async id => {
        pageId.value = id;
        parcels.value = null;
        let response = null;
        try {
            response = await axios({
                url: "api/parcels",
                params: {
                    parcelId: id
                }
            });
            parcels.value = response.data;
        } catch (error) {
            console.log(error);
        }
        return response;
    };

    return {
        getParcels,
        parcels,
        pageId
    };
};
